<template>
    <CModal @mtdclosemodal="mtdclosemodal" :show="boo_modal" :close-on-backdrop="false" :centered="false" :title="title" :size="'xl'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
        
        <div class="row mx-0 px-4 mb-2" id="content-timelinetable">
            <table class="table table-bordered border-main mb-0 px-0 text-xs">
                <caption class=" my-0 py-0"></caption>
                <thead class="">
                    <tr class="text-white border-white text-center bg-main">
                        <th scope="col">N°</th>
                        <th scope="col">ENFERMERA</th>
                        <th scope="col">FECHA</th>
                        <th scope="col">DETALLE</th>
                        <th v-if="type_kardex =='transfusiones_sanguineas'" scope="col">ACCIÓN</th>
                        
                    </tr>
                </thead>
                <tbody v-if="this.dataProcInvasivo.length > 0">
                    <tr v-for="(proc, index) in this.dataProcInvasivo" :key="index" class="px-1">
                        <td class="text-center"><span>{{ index + 1 }}</span></td>
                        <td class="text-center"><span>{{ proc.nurse.name }} {{ proc.nurse.last_name }}</span></td>
                        <td class="text-center"><span>{{ formatDate(proc.date) }} | {{ proc.hour }}</span></td>
                        <td class="text-center"><span>{{ proc.description }} </span></td>
                        <td class="text-center" v-if="type_kardex =='transfusiones_sanguineas'">
                            <span v-if="proc.file">   
                                <button  @click="openPdf(proc.file)" type="button" class="btn btn-sm btn-danger mt-1"><i class="fa fa-file-pdf"></i></button>      
                            </span>
                            <span v-else> - </span>
                        </td>
                    </tr>
                </tbody>
                <tbody class=" text-center" v-else>
                <tr>
                    <td colspan="19" class=" text-center">
                    <strong> No hay resultados</strong>
                    </td>
                </tr>
                </tbody>
            </table>
            </div>
        
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import { mapActions } from "vuex";
import moment from "moment";

export default {
    name: "c-medico-modal-proc-invasivo-view",

    data() {
        return {
            swal: null,
            validation: false,
            dataProcInvasivo: []
        }
    },
    components: {
        CModal,
        SweetAlert
    },
    props: {
        title: String,
        boo_modal: Boolean,
        id_medical_view: {
            type: Number,
            default: 0
        },
        patient_id: {
            type: Number,
            default: 0
        },
        type_kardex: {
            type: String,
            default: ''
        },
        type: {
            type: Number,
            default: 3
        },
        process: {
            type: Number,
            default: 0
        },
    },
    watch: {
        id_medical_view: {
            handler: function (newValue) {
                if (newValue != null && newValue != 0) {
                    this.mtdGetData();
                }
            },
            deep: true,
            immediate: true,
        },
    },
    created() {
    },
    mounted() {
    },
    methods: {
        ...mapActions(['get', 'post']),
        mtdGetData: function () {
            this.post({
                url: this.$store.getters.get__url + "/Hospitalization/procInvasivo",
                token: this.$store.getters.get__token,
                params:{
                    medical_act_id: this.id_medical_view,
                    type_kardex: this.type_kardex,
                    type: this.type,
                    process: this.process,
                },
            })
            .then((response) => {
                this.dataProcInvasivo = response.data;
            })
            .catch((errors) => {
                console.log(errors);
            });
        },
        mtdclosemodal() {
            this.$emit('mtdclosemodalprocinvasivonewview');
        },
        
        formatDate(date) {
            return date != null ? moment(date).format("DD/MM/YYYY") : "";
        },
        openPdf: function (url) {
            let nuevaUrl = "/assets/" + url;
            window.open(nuevaUrl, '_blank');
        },
    },
}
</script>